import React from 'react';

import { ProductModeEnum } from 'pages/b2c/Offers/models/product.model';
import { Message as OfferMessage, MessageType } from 'shared-types/user';

import ExpiredOfferMessage from './components/ExpiredOfferMessage';
import FreeTrialEndMessage from './components/FreeTrialEndMessage';
import NoOfferMessage from './components/NoOfferMessage';
import StartKaraokeMessage from './components/StartKaraokeMessage';

interface Props {
  offersMessageConfig: OfferMessage | undefined;
}

const Message: React.FC<Props> = ({ offersMessageConfig }) => {
  if (!offersMessageConfig) {
    return null;
  }

  switch (offersMessageConfig.type) {
    case MessageType.OngoingOffer:
      return <StartKaraokeMessage />;
    case MessageType.ExpiredFreeTrial:
      return <FreeTrialEndMessage />;
    case MessageType.ExpiredPass:
      return (
        <ExpiredOfferMessage
          productMode={ProductModeEnum.PAYMENT}
          productName={offersMessageConfig.productName}
        />
      );
    case MessageType.ExpiredSubscription:
      return <ExpiredOfferMessage productMode={ProductModeEnum.SUBSCRIPTION} />;
    case MessageType.NoOffer:
      return <NoOfferMessage />;
    default:
      return null;
  }
};

export default Message;
